module.exports = __webpack_public_path__ + "static/media/ic_mail.e86741be.svg";